import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const AnnouncementBasicInfoComponent = ({ handleInnerFormChange, selectedAnnouncement, announcementType }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <InputContainer
                        label="Announcment Type"
                        labelField="Text"
                        list={announcementType}
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'AnnouncmentTypeId'
                            )
                        }}
                        optionName='Choose announcement Type'
                        type="select"
                        value={selectedAnnouncement?.AnnouncmentTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Title"
                        name="Title"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Title'
                            )
                        }}
                        type="text"
                        value={selectedAnnouncement?.Title}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Description'
                            )
                        }}

                        type="text"
                        value={selectedAnnouncement?.Description}
                    />

                    <InputContainer
                        label="Published"
                        name="IsPublished"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsPublished'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsPublished}
                    />
                    <InputContainer
                        label="Limited To Route"
                        name="IsLimitedToRoute"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsLimitedToRoute'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsLimitedToRoute}
                    />
                    {selectedAnnouncement?.IsLimitedToRoute &&
                        <InputContainer
                            label="RoutePath"
                            name="RoutePath"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'RoutePath'
                                )
                            }}
                            type="text"
                            value={selectedAnnouncement?.RoutePath}
                        />}
                    <InputContainer
                        label="Display StartDate"
                        name="IsDisplayStartDateUtc"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsDisplayStartDateUtc'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsDisplayStartDateUtc}
                    />
                    {selectedAnnouncement?.IsDisplayStartDateUtc &&
                        <InputContainer
                            label="Start Date"
                            name="StartDateUtc"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'StartDateUtc'
                                )
                            }}
                            type="date"
                            value={selectedAnnouncement?.StartDateUtc}
                        />}

                    <InputContainer
                        label="Display EndDateUtc"
                        name="IsDisplayEndDateUtc"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsDisplayEndDateUtc'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsDisplayEndDateUtc}
                    />
                    {selectedAnnouncement?.IsDisplayEndDateUtc &&
                        <InputContainer
                            label="End Date"
                            name="EndDateUtc"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'EndDateUtc'
                                )
                            }}
                            type="date"
                            value={selectedAnnouncement?.EndDateUtc}
                        />}

                    <InputContainer
                        label="EnableLocation"
                        name="IsEnableLocation"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsEnableLocation'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsEnableLocation}
                    />
                    {selectedAnnouncement?.IsEnableLocation &&
                        <InputContainer
                            label="Location"
                            name="Location"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Location'
                                )
                            }}
                            type="text"
                            value={selectedAnnouncement?.Location}
                        />}
                    <InputContainer
                        label="RedirectionEnabled"
                        name="IsRedirectionEnabled"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsRedirectionEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsRedirectionEnabled}
                    />
                    {selectedAnnouncement?.IsRedirectionEnabled &&
                        <InputContainer
                            label="RedirectionURL"
                            name="RedirectionURL"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'RedirectionURL'
                                )
                            }}
                            type="text"
                            value={selectedAnnouncement?.RedirectionURL}
                        />}
                    <InputContainer
                        label="Contact Person Enabled"
                        name="IsContactPersonEnabled"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsContactPersonEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsContactPersonEnabled}
                    />
                    {selectedAnnouncement?.IsContactPersonEnabled &&
                        <><InputContainer
                            label="ContactPersonName"
                            name="ContactPersonName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContactPersonName'
                                );
                            }}
                            type="text"
                            value={selectedAnnouncement?.ContactPersonName} />
                            <InputContainer
                                label="ContactPersonTitle"
                                name="ContactPersonTitle"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'ContactPersonTitle'
                                    );
                                }}
                                type="text"
                                value={selectedAnnouncement?.ContactPersonTitle} /></>
                    }

                    <InputContainer
                        label="Contact PhoneNumber Enabled"
                        name="IsContactPhoneNumberEnabled"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsContactPhoneNumberEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsContactPhoneNumberEnabled}
                    />
                    {selectedAnnouncement?.IsContactPhoneNumberEnabled &&
                        <InputContainer
                            label="ContactPhoneNumber"
                            name="ContactPhoneNumber"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContactPhoneNumber'
                                )
                            }}
                            type="text"
                            value={selectedAnnouncement?.ContactPhoneNumber}
                        />}

                    <InputContainer
                        label="Contact Email Enabled"
                        name="IsContactEmailEnabled"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsContactEmailEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsContactEmailEnabled}
                    />
                    {selectedAnnouncement?.IsContactEmailEnabled &&
                        <InputContainer
                            label="Contact Email"
                            name="Contact Email"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContactEmail'
                                )
                            }}
                            type="text"
                            value={selectedAnnouncement?.ContactEmail}
                        />}

                    <InputContainer
                        label="Contact Address Enabled"
                        name="IsContactAddressEnabled"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event,
                                'IsContactAddressEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedAnnouncement?.IsContactAddressEnabled}
                    />
                    {selectedAnnouncement?.IsContactAddressEnabled &&
                        <><InputContainer
                            label="Address1"
                            name="Address1"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Address1'
                                );
                            }}
                            type="text"
                            value={selectedAnnouncement?.Address1} /><InputContainer
                                label="Address2"
                                name="Address2"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Address2'
                                    );
                                }}
                                type="text"
                                value={selectedAnnouncement?.Address2} />
                            <InputContainer
                                label="City"
                                name="City"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'City'
                                    );
                                }}
                                type="text"
                                value={selectedAnnouncement?.City} />
                            <InputContainer
                                label="ZipPostalCode"
                                name="ZipPostalCode"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'ZipPostalCode'
                                    );
                                }}
                                type="text"
                                value={selectedAnnouncement?.ZipPostalCode} /></>
                    }

                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    </>
)
export default AnnouncementBasicInfoComponent;
